import styled from 'styled-components';
import { lighten } from 'react-rainbow-components/styles/helpers/color';
import Input from 'components/Input';
import EmptyMessage from 'components/EmptyMessage';
import {
    GREY_200, GREY_50, GREY_700, GREY_800, PURPLE_100, PURPLE_800, WHITE,
} from '../../../constants';

export const Dropdown = styled.div`
    width: 25rem;
    padding: 1rem 1.25rem 0 1.25rem;
    flex-direction: column;
    align-items: flex-start;
    background: ${WHITE};
    border-radius: 1.5rem;
    box-shadow: 0px  4px 16px 0px rgba(75, 70, 92, 0.10);
`;

export const DropdownContent = styled.div`
    display: flex;
    flex-direction: column;
`;

export const DropdownHeader = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
`;

export const DropdownTitle = styled.h3`
    font-size: 1.125rem;
    font-weight: 700;
    line-height: 1.625rem;
    color: ${GREY_700};
    flex: 1;
`;

export const SearchInput = styled(Input)`
    width: 100%;

    span {
        left: 1rem;
    }

    svg {
        width: 1.5rem !important;
        height: 1.5rem !important;
        font-size: 1.5rem !important;
    }

    input {
        background: ${GREY_50};
        border-color: ${GREY_50};
        height: 3rem;
        line-height: 3rem;
        padding: 0px 1rem 0px 3rem;

        &:focus {
            padding-left: 2.9375rem;
        }
    }
`;

export const StyledEmptyMessage = styled(EmptyMessage)`
    padding: 2rem 0 3rem 0;
`;

export const ListContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: fit-content;
    max-height: 25rem;
    overflow: hidden;
`;

export const StyledUl = styled.ul`
    margin: 0;
    padding: 1.25rem 0;
    list-style: none;
    box-sizing: border-box;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    height: 100%;
        
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
        display: none;
    }   
`;

export const StyledLi = styled.li`
    box-sizing: border-box;
    margin: 0px;
    padding: 0px;
    list-style: none;
    width: 100%;
`;

export const TopGradient = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2rem;
    background: linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, ${WHITE} 50%);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    color: ${GREY_200};
`;

export const BottomGradient = styled.div`
    position: absolute;
    bottom: 0rem;
    left: 0;
    right: 0;
    height: 2rem;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, ${WHITE} 50%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${GREY_200};
`;

export const StyledOption = styled.div`
    display: flex;
    align-items: center;
    padding: 0.5rem 0.5rem 0.5rem 1rem;
    border-radius: 1rem;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;
    color: ${GREY_800};
    gap: 0.75rem;
    width: 100%;

    &:hover {
        background-color: ${lighten(PURPLE_100, 0.25)};
        color: ${PURPLE_800};
    }
`;

export const OptionName = styled.h4`
    display: inline-flex;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
    text-overflow: ellipsis;
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.75rem;
    margin: 0;
    text-overflow: ellipsis;
    overflow: hidden;
`;
